<template>
    <div>
        <b-modal id="modal_form"
                 ref="modal_form"
                 :title="modal_titulo"
                 :ok-title="modal_botao"
                 close-title="Fechar"
                 size="lg"
                 v-model="showModal"
                 :ok-disabled=form.errors.any()
                 @ok="onStoreComplementar">
                <form @submit.stop.prevent="onStoreComplementar" @keydown="form.errors.clear($event.target.name)">

                <b-container fluid class="p-a-0">
                    <b-row no-gutters>
                        <h3 class="header_destaque">Dados CTE Original - {{ this.form.descr_complementar }}</h3>
                    </b-row>
                </b-container>
              <b-container fluid class="p-a-0">
                  <b-row no-gutters>
                      <b-col>
                          <label>CST *</label>
                          <multiselect v-model="cstSelected"
                          :options="optionsParamCst"
                          track-by="value"
                          label="label"
                          :hide-selected="true"
                          placeholder="Selecione"
                          tag-placeholder="Selecionar"
                          select-label="Selecionar"
                          selected-label="Selecionado"
                          deselect-label="Remover"
                          ></multiselect>
                          <b-form-feedback class="text-danger" v-text="form.errors.get('cst.value')" v-if="form.errors.has('cst.value')"></b-form-feedback>
                      </b-col>

                       <b-col>
                           <label>CFOP *</label>
                           <multiselect v-model="cfopSelected"
                           :options="optionsLivCfop"
                           track-by="value"
                           label="label"
                           :hide-selected="true"
                           placeholder="Selecione"
                           tag-placeholder="Selecionar"
                           select-label="Selecionar"
                           selected-label="Selecionado"
                           deselect-label="Remover"
                           ></multiselect>
                           <b-form-feedback class="text-danger" v-text="form.errors.get('cfop.value')" v-if="form.errors.has('cfop.value')"></b-form-feedback>
                       </b-col>
                       <b-col>
                           <label>Tipo Custo</label>
                           <multiselect v-model="custoSelected"
                           :options="optionsCustos"
                           track-by="value"
                           label="label"
                           :hide-selected="true"
                           placeholder="Selecione"
                           tag-placeholder="Selecionar"
                           select-label="Selecionar"
                           selected-label="Selecionado"
                           deselect-label="Remover"
                           ></multiselect>
                           <b-form-feedback class="text-danger" v-text="form.errors.get('custo.value')" v-if="form.errors.has('custo.value')"></b-form-feedback>
                       </b-col>
                </b-row>
                    <b-row no-gutters>
                        <b-col>
                          <label>Valor *</label>
                          <currency-input
                              class="form-control"
                              v-model="form.vlr_cte"
                              placeholder=""
                              :auto-decimal-mode="true"
                              :locale="getCurrency.locale"
                              style="text-align: right"
                              v-on:keyup="calcCteCompl"
                              :currency="{ prefix: 'R$ '}"
                              :distraction-free="getCurrency"/>
                          <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_cte')" v-if="form.errors.has('vlr_cte')"></b-form-feedback>
                        </b-col>
                        <b-col >
                          <label>Alíquota</label>
                          <currency-input
                              class="form-control"
                              v-model="form.vlr_aliquota"
                              placeholder=""
                              :auto-decimal-mode="true"
                              :locale="getCurrency.locale"
                              style="text-align: right"
                              v-on:keyup="calcCteCompl"
                              :currency="{ prefix: '% '}"
                              :distraction-free="getCurrency"/>
                            <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_aliquota')" v-if="form.errors.has('vlr_aliquota')"></b-form-feedback>
                        </b-col>
                        <b-col  v-if="form.cd_cst==90 || form.cd_cst==20">
                            <label>% Redução BC</label>
                            <currency-input
                                class="form-control"
                                v-model="form.percentual_reducao_bc"
                                placeholder=""
                                :auto-decimal-mode="true"
                                :locale="getCurrency.locale"
                                style="text-align: right"
                                v-on:keyup="calcCteCompl"
                                :currency="{ prefix: '% '}"
                                :distraction-free="getCurrency"/>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('percentual_reducao_bc')" v-if="form.errors.has('percentual_reducao_bc')"></b-form-feedback>
                      </b-col>
                        <b-col >
                            <label>Imposto </label>
                            <currency-input
                                class="form-control"
                                v-model="form.vlr_imposto"
                                placeholder=""
                                disabled
                                :auto-decimal-mode="true"
                                :locale="getCurrency.locale"
                                style="text-align: right"
                                v-on:keyup="calcCteCompl"
                                :currency="{ prefix: 'R$ '}"
                                :distraction-free="getCurrency"/>
                            <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_imposto')" v-if="form.errors.has('vlr_imposto')"></b-form-feedback>
                      </b-col>
                      <b-col>
                          <label>Valor Total do CTE</label>
                          <currency-input
                              class="form-control"
                              v-model="form.vlr_total"
                              placeholder=""
                              disabled
                              :auto-decimal-mode="true"
                              :locale="getCurrency.locale"
                              style="text-align: right"
                              v-on:keyup="calcCteCompl"
                              :currency="{ prefix: 'R$ '}"
                              :distraction-free="getCurrency"/>
                          <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_total')" v-if="form.errors.has('vlr_total')"></b-form-feedback>
                       </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col>
                            <label>Observação</label>
                            <b-form-textarea id="textarea1"
                                             name="obs"
                                             v-model="form.obs"
                                             placeholder="Observação"
                                             :rows="4"
                                             :max-rows="6">
                            </b-form-textarea>
                            <b-form-feedback class="text-danger" v-text="form.errors.get('obs')" v-if="form.errors.has('obs')"></b-form-feedback>
                        </b-col>
                        <b-col>
                            <label>Observação Fiscal</label>
                            <b-form-textarea id="textarea2"
                                             name="obs_fiscal"
                                             v-model="form.obs_fiscal"
                                             placeholder="Observação Fiscal"
                                             :rows="4"
                                             :max-rows="6">
                            </b-form-textarea>
                            <b-form-feedback class="text-danger" v-text="form.errors.get('obs_fiscal')" v-if="form.errors.has('obs_fiscal')"></b-form-feedback>
                        </b-col>
                    </b-row>
            </b-container>
            </form>

            <div slot="modal-footer" class="w-100">
                   <div class="float-left"><spinner v-if="loading" message="Gerando..."></spinner></div>
                   <div class="float-right">
                       <b-btn @click="showModal=false" variant="secondary">
                         Cancelar
                       </b-btn>
                       <b-btn @click="onStoreComplementar($event)" variant="secondary" :disabled="isDisabled">
                         Gerar CTE
                       </b-btn>
                   </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import accounting from 'accounting'
export default {
components: {
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingDataModelo: true,
      showModal: false,
      optionsParamCst: [],
      optionsLivCfop: [],
      optionsCustos: [],
      cstSelected: [],
      cfopSelected: [],
      custoSelected: [],
      form: new Form({
          cd_cst: '',
          parcst_id: '',
          vlr_cte: 0,
          vlr_aliquota: 0,
          vlr_imposto: 0,
          vlr_total: 0,
          percentual_reducao_bc: 0,
          doccte_id: '',
          custo_id: '',
          obs: '',
          cfop_id: '',
          obs_fiscal: '',
          doc: [],
          doc_cte: [],
          doc_cte_partes_env: [],
          modal: '',
          tp_cte: '',
      }),
      helpForm: new Form({statusRecord: [], params: [], search: ''}),
      fields: [],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
watch: {
    cstSelected(obj) {
        this.form.parcst_id = obj.value;
        this.form.cd_cst = obj.cd;
    },
    cfopSelected(obj) {
        this.form.cfop_id = obj.value;
    },
    custoSelected(obj) {
        this.form.custo_id = obj.value;
    },
},
methods: {
    onCreate(data) {
        this.modal_titulo = "Gerar CTE Complementar";
        this.modal_botao = "Gerar CTE";
        this.modal_acao = "i";
        this.isDisabled = false;
        this.form.reset();
        this.optionsParamCst = [];
        this.optionsLivCfop = [];
        this.optionsCustos = [];
        this.form.vlr_aliquota = parseInt(0, 10);
        this.form.percentual_reducao_bc = parseInt(0, 10);
        this.form.vlr_total = parseInt(0, 10);
        this.$parent.optionsParamCst.forEach((obj)=>
        {
            this.optionsParamCst.push({ label: obj.label, value: obj.value , cd: obj.cd})
        })
        this.$parent.optionsLivCfop.forEach((obj)=>
        {
            this.optionsLivCfop.push({ label: obj.label, value: obj.value})
        })
        this.$parent.optionsCustos.forEach((obj)=>
        {
            this.optionsCustos.push({ label: obj.label, value: obj.value})
        })
        this.form.doc = data;
        this.form.descr_complementar = "Número fiscal: " + data.num_fiscal + " | Número controle: " + data.num_controle + " |  CFOP : " + data.doc_cte.cfop.cd + " |  CST : " + data.doc_cte.doc_cte_imposto.param_cst.cd;
        this.form.doc_cte = data.doc_cte;
        this.form.doc_cte_partes_env = data.doc_cte_partes_env;
        this.form.modal = data.b_modal.cd;
        this.form.doccte_id = data.doccte_id;
        //this.cstSelected          = {label: data.doc_cte.doc_cte_imposto.param_cst.cd+" - "+data.doc_cte.doc_cte_imposto.param_cst.descr, value: data.doc_cte.doc_cte_imposto.param_cst.parcst_id, cd: data.doc_cte.doc_cte_imposto.param_cst.cd};
        //this.cfopSelected         = {label: data.doc_cte.cfop.descr, value: data.doc_cte.cfop.cfop_id};
        //this.custoSelected         = {label: data.doc_cte.cfop.descr, value: data.doc_cte.cfop.cfop_id};
        //this.form.obs = data.doc_cte.doc_cte_adicional.observacao_geral;
        //this.form.obs_fiscal = data.doc_cte.doc_cte_adicional.observacao_fisco;
        //this.form.vlr_aliquota = parseInt(data.doc_cte.doc_cte_imposto.aliquota_icms, 10); // Formato vem apenas 12, transformando em 0,12
        if(data.doc_cte.doc_cte_imposto.percentual_reducao_bc == null)
        {
        //    this.form.percentual_reducao_bc = parseInt(0, 10);
        }
        else
        {
        //    this.form.percentual_reducao_bc = parseInt(data.doc_cte.doc_cte_imposto.percentual_reducao_bc, 10); // Formato vem apenas 12, transformando em 0,12
        }
        // Calcula o valor do CTe
        this.calcCteCompl();
        this.$refs.modal_form.show();
    },
    onStoreComplementar() {
        this.loading = true;
        this.isDisabled = true;
        this.form.tp_cte = 1; // CTE Complementar
        this.form.post('/api/cte/complementar/store').then(response => {
                new ReturnApi(response, this)
                if(this.metodo!=null)
                {
                   this.metodo();
                }
                else
                {
                    this.$parent.onFilterReset();
                }
            })
            .catch(errors => {
                new ReturnApi(errors, this)
            });
    },
    calcCteCompl() {
        this.vn_vlr_cte = this.form.vlr_cte;
        this.vn_aliquota = this.form.vlr_aliquota;

        this.form.vlr_imposto = Number((this.vn_vlr_cte/((100-this.vn_aliquota)/100))-this.vn_vlr_cte);
        this.vn_vlr_total = this.vn_vlr_cte+this.form.vlr_imposto;
        this.form.vlr_total = Number(this.vn_vlr_total);
    },
    formatNumber(value) {
        return accounting.formatNumber(value, 2, '.', ',')
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    },
    getCurrency: {
        get() {
            return this.$store.getters.currency;
        }
    },
}
}
</script>
